export function btnmatrix(ctx) {
    return {
        styles: {
            main: { ...ctx.pretty, radius: 8, padding: 0, border_width: 1 },
            // item_buttons part — uses btn style
            item_buttons: {
                bg_color:     ctx.COLOR_BG,
                border_color: ctx.COLOR_BG_BORDER,
                border_width: 1,
                radius:       5,
                text_color:   ctx.COLOR_BG_TEXT,
                text_font:    32,
            },
        },
    };
}
